<template>
  <b-modal ref="modalGestionBarquettes" size="s" 
    :title="titreModal"
    :ok-title="titreBoutonOk"
    cancel-title="Annuler"
    no-close-on-backdrop
    @ok="enregistrerBarquette()"
    @show="initialiserModale()"
    @hidden="quitterModale()">
    <template slot="default">
      <div>
        <div class="form-group">
          <label for="designationBarquette">Désignation</label>
          <input id="designationBarquette" type="text" title="Description/modèle de la barquette" v-model.trim="barquette.designation" style="width:100%" @input="key++;"/>
          <div class="error" v-if="!barquette.designation">Ce champ est requis</div>
          <div v-else>&nbsp;</div>
        </div>

        <div class="form-group">
          <label for="tailleBarquette">Taille (Nombre de portions)</label><br/>
          <InputNumber id="tailleBarquette" v-model="barquette.taille" typeFiltre="quantiteEntiere" style="width:48px;" @input="key++;" />
          <div class="error" v-if="!barquette.taille">Ce champ est requis</div>
          <div v-else>&nbsp;</div>
        </div>

        <div class="form-group">
          <label>Active</label><br/>
          <ToggleButton v-model="barquette.active" :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#16D39A', unchecked: '#CCCCCC'}" :height="30" :width="85" />
        </div>

      </div>
    </template>
  </b-modal>
</template>

<script>
import { connecteData } from '@/mixins/connecteData'
import { modifierBarquette } from '@/api/gpao/production'
import { showAlerts } from "@/mixins/alerts"
import InputNumber from "@/components/Inputs/InputNumber"

export default {
  name: "ModalGestionBarquettes",
  props: {
    
  },
  components: { InputNumber },
  mixins: [ connecteData, showAlerts ],
  data() {
    return {
      barquette: {},
      listeAutresBarquettes: [],
      titreModal: "",
      titreBoutonOk: "",
      key: 0
    }
  },
  computed: {

  },
  methods: {
    initialiserModale() {

    },
    checkBarquette() {
      let message = ""

      if (this.barquette.designation.length > 20) {
        this.barquette.designation = this.barquette.designation.substr(0, 20)
      }

      if (!this.barquette.taille)
        message += "La taille de la barquette n'est pas valide"

      if (!this.barquette.designation)
        message += "La désignation de la barquette n'est pas valide"

      if (this.listeAutresBarquettes.some(x => x.designation == this.barquette.designation))
        message += "La barquette " + this.barquette.designation + " existe déjà"
      
      if (message && message != "") {
        this.alerteErreur(message)
        return false
      }
      
      return true
    },
    async enregistrerBarquette() {
      
      if (this.checkBarquette()) {
        await modifierBarquette(this.barquette)
      }

      this.$emit("refreshBarquette")

    },
    quitterModale() {
      this.$emit("refreshBarquette")
    },
    show(vueBarquette, listeBarquettes) {
      if (vueBarquette.id && vueBarquette.id !== 0) {
        this.titreModal = "Modifier une barquette"
        this.titreBoutonOk = "Modifier"
      } else {
        this.titreModal = "Ajouter une barquette"
        this.titreBoutonOk = "Ajouter"
      }

      this.barquette = vueBarquette
      this.listeAutresBarquettes = listeBarquettes
      
      this.$refs.modalGestionBarquettes.show()
    },
    hide() {
      this.$emit("refreshBarquette")
      this.$refs.modalGestionBarquettes.hide()
    }
  }
}
</script>